module.exports = __webpack_public_path__ + "images/fungibility.png?v=cd74d2492322a78d83d9caa675f6a745";